import { render, staticRenderFns } from "./joinedIntranetBusiness.vue?vue&type=template&id=05478d33&scoped=true"
import script from "./joinedIntranetBusiness.vue?vue&type=script&lang=js"
export * from "./joinedIntranetBusiness.vue?vue&type=script&lang=js"
import style0 from "./joinedIntranetBusiness.vue?vue&type=style&index=0&id=05478d33&prod&lang=css"
import style1 from "./joinedIntranetBusiness.vue?vue&type=style&index=1&id=05478d33&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05478d33",
  null
  
)

export default component.exports